<template>
  <div class="field-pane">
    <div class="field-pane-header">
      <div class="field-pane-header-title">
        <el-button class="field-pane-header-back-btn" size="mini" icon="el-icon-arrow-left" @click="closeFieldEdit">
          <span>返回</span>
        </el-button>
        <span>{{ paneTitle }}</span>
      </div>
      <i class="el-icon-close field-pane-header-close" @click="closeFieldEdit"></i>
    </div>

    <div class="field-pane-container" v-loading="paneLoading">
      <div class="field-pane-content" :style="{ padding: 0 }" v-if="fieldEditorInfo.show">
        <fieldEditorNew
          :courseDetail="newCourseDetail || courseDetail"
          :chartIndexId="chartIndexId"
          :fieldDetail="fieldEditorInfo.detail"
          :fieldDefaultInfo="fieldDefaultInfo"
          :couldSave="fieldEditorInfo.couldSave"
          @clearRecommend="fieldDetail => $emit('clearRecommend', fieldDetail)"
          @updCourseDetail="updCourseDetailHandle"
          @close="closeFieldEdit"
        />
      </div>

      <template v-if="!justEditField">
        <div class="field-pane-search-content" v-show="!fieldEditorInfo.show && mode !== 'importOwner'">
          <el-input
            placeholder="输入关键词进行过滤"
            prefix-icon="el-icon-search"
            v-model="fieldKeyword"
            clearable
            @input="updSearchHandle"
          />
        </div>
        <div class="field-pane-content" v-show="!fieldEditorInfo.show && !fieldKeyword">
          <div class="field-pane-empty-text" v-if="treeContainerArr.length < 1 && !paneLoading">暂无数据</div>
          <div class="field-tree-container" v-for="(treeItem, treeIdx) in treeContainerArr" :key="treeItem.label">
            <div class="field-tree-header">
              <div class="field-tree-title">{{ treeItem.label }}</div>
              <div class="field-tree-desc">{{ treeItem.desc }}</div>
            </div>
            <div class="course-list-filter" v-if="treeItem.label === '课题标签'">
              <el-input v-model="courseFilterKeyword" placeholder="请输入关键词查找..." @input="getMyCoursewareList" />
            </div>
            <el-tree
              :data="treeItem.data"
              lazy
              :load="loadChildHandle"
              :props="{ isLeaf }"
              node-key="_id"
              :default-expanded-keys="treeItem.defaultExpandedKeys"
              :expand-on-click-node="false"
              ref="treeRefs"
            >
              <div slot-scope="{ node, data }" class="field-node-content" @click.prevent="tapFieldHandle(data)">
                <el-checkbox
                  :value="fieldCheckIds"
                  :label="data._id"
                  :disabled="data.isCourse || data._id === 'custom_root' || data.isGroupField"
                >
                  <span></span>
                </el-checkbox>
                <div class="node-item single-ellipsis">
                  <span>{{ data.title || '-' }}</span>
                  <i
                    v-if="isAdmin && data.system"
                    class="iconfont iconbianji node-item-chekck-rule-btn"
                    @click.stop="checkFieldDetail(data)"
                  ></i>
                </div>
                <div
                  class="field-node-del-icon"
                  v-if="treeItem.isOwner && data._id !== 'custom_root'"
                  @click.stop="delOwnerFieldHandle(node, data, treeIdx)"
                >
                  <i class="iconfont el-icon-delete"></i>
                </div>
              </div>
            </el-tree>
          </div>
        </div>
        <div
          class="field-pane-search-ul"
          v-show="!fieldEditorInfo.show && !!fieldKeyword"
          v-loading="searchLoading > 0"
        >
          <div
            class="field-pane-search-li"
            v-for="fieldItem in searchList"
            :key="fieldItem._id"
            @click.prevent="tapFieldHandle(fieldItem)"
          >
            <div class="field-li-tag">
              <span v-if="fieldItem.system">预置</span>
              <span v-else-if="fieldItem.coursewareId">课题</span>
              <span v-else>自定义</span>
            </div>
            <div class="field-li-info">
              <div class="field-li-title single-ellipsis" v-html="formatTitleHandle(fieldItem.title)"></div>
              <div class="field-li-fullname single-ellipsis">{{ fieldItem.full_name }}</div>
            </div>
            <el-checkbox class="field-li-check" :value="fieldCheckIds" :label="fieldItem._id">
              <span></span>
            </el-checkbox>
          </div>
          <div class="field-pane-empty-text" v-show="fieldKeyword && searchLoading < 1 && searchList.length < 1">
            <span>暂无数据</span>
          </div>
        </div>
      </template>
    </div>

    <div class="field-pane-tools" v-if="!fieldEditorInfo.show">
      <el-button @click="closeFieldEdit">
        <span>取消</span>
      </el-button>
      <el-button type="primary" :disabled="fieldChecks.length < 1" :loading="confirmLoading" @click="importFieldHandle">
        <span>确认</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { debounce, uniqueId } from 'lodash';
import { services } from '@/service';
import fieldEditorNew from '@/components/fieldEditorNew';
import { transformColumnToSource, clearColumnInvalidAttr, formatColumnToFormInfo, initColumns } from '@/lib/utils';
export default {
  components: { fieldEditorNew },
  data() {
    return {
      fieldEditorInfo: {
        show: false,
        detail: null,
        couldSave: false
      },
      confirmLoading: false,
      fieldKeyword: '',
      paneLoading: false,
      courseFields: [],
      ownerFields: [],
      systemFields: [],
      fieldChecks: [],
      searchLoading: 0,
      searchList: [],
      newCourseDetail: null,
      courseFilterKeyword: ''
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      required: true,
      validator: modeStr => ['createField', 'updateField', 'importOwner', 'importSystem'].includes(modeStr)
    },
    courseDetail: {
      type: Object,
      required: true
    },
    chartIndexId: {
      type: Number,
      default: -1
    },
    fieldDetail: {
      type: Object,
      default: () => null
    },
    fieldDefaultInfo: {
      type: Object,
      default: () => null
    }
  },
  inject: {
    courseUnitGroups: { default: () => [] }
  },
  computed: {
    isAdmin() {
      return !!this.$store.getters.isAdmin;
    },
    justEditField() {
      return ['createField', 'updateField'].includes(this.mode);
    },
    paneTitle() {
      if (!this.fieldEditorInfo.show) {
        if (this.mode === 'importOwner') {
          return '引用其他课题标签';
        }

        if (this.mode === 'importSystem') {
          return '引用系统预置标签';
        }
      }

      return '标签编辑器';
    },
    instrumentType() {
      return this.courseDetail._source.instrumentType;
    },
    treeContainerArr() {
      const arr = [];
      if (this.mode === 'importOwner') {
        if (this.courseFilterKeyword || this.courseFields.length > 0) {
          arr.push({
            label: '课题标签',
            desc: '我创建及加入协作课题的标签，拿来即用',
            data: this.courseFields,
            defaultExpandedKeys: []
          });
        }
        if (this.ownerFields.length > 0) {
          arr.push({
            label: '个人标签库',
            desc: '收藏或自定义的标签，辅助快速调用',
            data: this.ownerFields,
            defaultExpandedKeys: ['custom_root'],
            isOwner: true
          });
        }
      }
      if (this.mode === 'importSystem' && this.systemFields.length) {
        arr.push({
          label: '预置标签',
          desc: '系统预置标签，拿来即用（对预置标签进行覆盖、追加、还原操作后，无法恢复初始化，请谨慎操作。）',
          data: this.systemFields,
          defaultExpandedKeys: this.systemFields.map(item => item._id)
        });
      }
      return arr;
    },
    fieldCheckIds() {
      return this.fieldChecks.map(item => item._id);
    }
  },
  created() {
    this.updSearchHandle = debounce(this.updSearchHandle.bind(this), 300);
    if (this.justEditField) {
      this.checkFieldDetail(this.fieldDetail, true);
    }
  },
  mounted() {
    if (!this.justEditField) {
      this.initFieldTreeHandle();
    }
  },
  methods: {
    checkFieldDetail(fieldDetail, couldSave = false) {
      this.fieldEditorInfo.detail = fieldDetail;
      this.fieldEditorInfo.couldSave = couldSave;
      this.fieldEditorInfo.show = true;
    },
    tapFieldHandle(item) {
      if (item.isCourse || item._id === 'custom_root' || item.isGroupField) {
        return;
      }
      const idx = this.fieldChecks.findIndex(o => o._id === item._id);
      if (idx === -1) {
        this.fieldChecks.push(item);
      } else {
        this.fieldChecks.splice(idx, 1);
      }
    },
    formatTitleHandle(title) {
      try {
        return title.replace(new RegExp(this.fieldKeyword, 'g'), val => {
          return `<span style="color: #1991fb;">${val}</span>`;
        });
      } catch (err) {
        return title;
      }
    },
    isLeaf(data) {
      return data.child_count < 1;
    },
    closeFieldEdit() {
      if (!this.fieldEditorInfo.show || this.justEditField) {
        this.closeHandle();
      } else {
        this.fieldEditorInfo.show = false;
      }
    },
    closeHandle() {
      if (this.newCourseDetail) {
        this.$emit('updCourseDetail', this.newCourseDetail);
      }
      this.$emit('update:show', false);
    },
    updCourseDetailHandle(detail) {
      this.newCourseDetail = detail;
      this.$emit('updCourseDetail', this.newCourseDetail);
    },
    async importFieldHandle() {
      try {
        this.confirmLoading = true;

        const userInfo = this.$store.getters.userInfo;
        const courseDetail = this.newCourseDetail || this.courseDetail;

        const newFieldsPromises = this.fieldChecks.map(item => {
          const newId = uniqueId(`${userInfo.id}_${Date.now()}_`);

          const formatResult = clearColumnInvalidAttr(formatColumnToFormInfo(item));

          if (formatResult.errMsg) {
            return Promise.reject(formatResult.errMsg);
          }

          const source = transformColumnToSource({
            info: formatResult.info,
            typeList: services.labelRelation.getEntityRelationGroup()
          });
          let sysId = '';
          let groupRelationId = 'case';
          if (item.system) {
            sysId = item._id;
            groupRelationId = item.groupRelationId;
          }
          const groupItem = this.courseUnitGroups.find(groupItem => groupItem.id === groupRelationId);
          const fieldParams = {
            type: 'add',
            id: newId,
            source: {
              ...source,
              groupRelationId: groupItem?.id || 'case',
              ownerId: this.$store.getters.userInfo.id,
              sys_id: sysId,
              create_time: source.update_time,
              coursewareId: courseDetail._id,
              parentId: '',
              field_name: newId,
              full_path: newId,
              full_name: source.chinese_name,
              groups: courseDetail._source.instrumentType,
              system: false
            }
          };
          if (source.deputy_field_type === 'dict') {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async resolve => {
              try {
                const { data } = await services.caseRule.getFieldDictVal({
                  labelId: item._id,
                  keyword: '',
                  courseId: '',
                  size: 10000
                });
                fieldParams.source.dictClassifyValue = data.dict_classify_value || [];
                fieldParams.source.dictValue = fieldParams.source.dictClassifyValue.slice(0, 6).map(o => o.labelName);
              } catch (err) {
                this.$error(err);
              } finally {
                resolve(fieldParams);
              }
            });
          }
          return Promise.resolve(fieldParams);
        });

        const newFieldsArr = await Promise.all(newFieldsPromises);

        await services.courseware.mulitAddFields({ coursewareId: courseDetail._id, children: newFieldsArr });

        const newFields = initColumns(
          newFieldsArr.map(item => {
            return { _id: item.id, child_count: 0, _source: item.source };
          })
        );

        let newCourseSource = null;

        if (this.chartIndexId === -1) {
          newCourseSource = { ...courseDetail._source, fields: [...courseDetail._source.fields, ...newFields] };
        } else {
          const charts = [...courseDetail._source.chart];
          const chartIdx = charts.findIndex(chartItem => chartItem.index_id === this.chartIndexId);
          const chartItem = charts[chartIdx];
          charts.splice(chartIdx, 1, {
            ...chartItem,
            fields: [...chartItem.fields, ...newFields]
          });
          newCourseSource = { ...courseDetail._source, chart: charts };
        }

        await services.courseware.saveCourseware(courseDetail._id, newCourseSource);

        services.caseRule.autuAddTag({
          courseId: courseDetail._id,
          courseTitle: courseDetail._source.title,
          dataSource: JSON.stringify({ query: [] }),
          fieldDetailArr: newFields,
          runType: '追加'
        });

        this.newCourseDetail = { ...courseDetail, _source: newCourseSource };

        this.$message.success('标签引用成功');
        this.closeHandle();
      } catch (err) {
        this.$error(err);
      } finally {
        this.confirmLoading = false;
      }
    },
    async initFieldTreeHandle() {
      try {
        this.paneLoading = true;

        if (this.mode === 'importSystem') {
          await this.initSystemTreeHandle();
        }

        if (this.mode === 'importOwner') {
          await this.initOwnerTreeHandle();
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.paneLoading = false;
      }
    },
    async initSystemTreeHandle() {
      const result = await services.labelRelation.getLabelRelationByCustom({
        coursewareId: this.courseDetail._id,
        must: [
          {
            term: {
              'parentId.keyword': ''
            }
          },
          {
            term: {
              'groups.keyword': this.instrumentType
            }
          }
        ]
      });

      this.systemFields = result.filter(item => item.system);
    },
    async initOwnerTreeHandle() {
      let [ownerFields] = await Promise.all([
        services.labelRelation.getLabelRelationByCustom({
          coursewareId: this.courseDetail._id,
          must: [
            {
              term: {
                'parentId.keyword': ''
              }
            },
            {
              term: {
                'groups.keyword': this.instrumentType
              }
            },
            {
              term: {
                'ownerId.keyword': this.$store.getters.userInfo.id
              }
            }
          ]
        }),
        this.getMyCoursewareList()
      ]);

      ownerFields = ownerFields.filter(item => !item.system);

      this.getMyCoursewareList = debounce(this.getMyCoursewareList.bind(this), 300);

      if (ownerFields.length > 0) {
        this.ownerFields = [
          {
            title: '自定义标签',
            _id: 'custom_root',
            children: ownerFields,
            child_count: ownerFields.length
          }
        ];
      }
    },
    async getMyCoursewareList(keyword = '') {
      try {
        const params = {
          page: 0,
          size: 20,
          groups: this.instrumentType,
          excludeId: [this.courseDetail._id],
          type: '实证分析'
        };

        if (keyword.trim()) {
          params.title = keyword.trim();
        }

        const courseResult = await services.courseware.fetchCoursewareList(params);

        if (this.courseFilterKeyword !== keyword) {
          return;
        }

        const courseList = courseResult.data.filter(item => {
          return item._source.title !== undefined;
        });

        this.courseFields = courseList.map(item => {
          return {
            title: item._source.title,
            _id: item._id,
            isCourse: true
          };
        });
      } catch (err) {
        this.$error(err);
      }
    },
    async loadChildHandle(node, resolve) {
      if (Array.isArray(node.data)) {
        resolve(node.data);
        return;
      }
      if (node.data._id === 'custom_root' || (node.data.children || []).length > 0) {
        resolve(node.data.children);
        return;
      }
      try {
        let result = [];
        if (node.data.isCourse) {
          result = await services.courseware.getFields(node.data._id);
        } else {
          result = await services.labelRelation.getLabelRelationByParent({
            parentId: node.data.columnKey,
            instrumentType: this.instrumentType,
            coursewareId: this.courseDetail._id
          });
        }
        node.data.child_count = result.length;
        resolve(result);
      } catch (err) {
        this.$error(err);
      }
    },
    async updSearchHandle() {
      if (!this.fieldKeyword) {
        this.searchLoading = 0;
        this.searchList = [];
        return;
      }
      try {
        this.searchLoading++;

        const must = [
          {
            match_phrase: {
              chinese_name: this.fieldKeyword
            }
          },
          {
            term: {
              'groups.keyword': this.instrumentType
            }
          }
        ];

        if (this.mode === 'importOwner') {
          must.push({
            term: {
              'ownerId.keyword': this.$store.getters.userInfo.id
            }
          });
        }

        let result = await services.labelRelation.getLabelRelationByCustom({
          coursewareId: this.courseDetail._id,
          must
        });

        if (this.mode === 'importSystem') {
          result = result.filter(item => item.system && !item.isGroupField);
        }

        if (this.mode === 'importOwner') {
          result = result.filter(item => !item.system);
        }

        if (this.fieldKeyword) {
          this.searchList = result;
        }
      } catch (err) {
        this.$error(err);
      } finally {
        if (this.searchLoading > 0) {
          this.searchLoading--;
        }
      }
    },
    async delOwnerFieldHandle(nodeItem, item, treeIdx) {
      if (item.child_count > 0) {
        this.$message.warning('无法删除，因为该标签下有子标签');
        return;
      }
      this.$confirm(`是否删除标签【${item.title}】?`, '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return;
          }
          try {
            instance.confirmButtonLoading = true;

            const treeRef = this.$refs.treeRefs[treeIdx];

            await services.caseRule.delCaseLabelRule(item._id);

            if (nodeItem.parent && nodeItem.parent.data && !isNaN(nodeItem.parent.data.child_count)) {
              nodeItem.parent.data.child_count--;
            }

            this.$message.success('标签删除成功');
            const idx = this.fieldChecks.findIndex(o => o._id === item._id);
            if (idx !== -1) {
              this.fieldChecks.splice(idx, 1);
            }
            treeRef.remove(item);

            done();
          } catch (err) {
            this.$error(err);
          } finally {
            instance.confirmButtonLoading = false;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.field-pane {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .field-pane-header {
    box-sizing: border-box;
    height: 50px;
    border-bottom: 1px solid #e8ebef;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .field-pane-header-title {
      display: flex;
      align-items: center;
      color: #2c3443;
      font-size: 16px;

      & > span {
        font-weight: bold;
      }

      .field-pane-header-back-btn {
        box-shadow: 0px 0px 6px 2px rgb(48 57 69 / 10%);
        margin-right: 10px;
      }
    }

    .field-pane-header-close {
      color: #9599a5;
      font-size: 18px;
      padding: 5px;
      padding-right: 0;
      cursor: pointer;
    }
  }

  .field-pane-container {
    box-sizing: border-box;
    flex: 1;
    height: 0;
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;

    .field-pane-search-content {
      margin-bottom: 10px;
      padding: 0 20px;
    }

    .field-pane-empty-text {
      color: #9599a5;
      font-size: 14px;
      text-align: center;
      margin: 50px 0;
    }

    .field-pane-content {
      box-sizing: border-box;
      flex: 1;
      height: 0;
      width: 100%;
      overflow: auto;
      padding: 0 20px;
      &::-webkit-scrollbar {
        display: none;
      }

      .field-tree-container {
        margin-top: 30px;

        &:first-child {
          margin-top: 0;
        }
        .course-list-filter {
          margin-bottom: 10px;
        }
        .field-tree-header {
          margin-bottom: 10px;
          .field-tree-title {
            color: #3d465a;
            font-size: 14px;
            line-height: 20px;
            font-weight: bold;

            & > span {
              font-weight: inherit;
            }
          }
          .field-tree-desc {
            color: #9599a5;
            font-size: 12px;
            line-height: 18px;
          }
        }

        ::v-deep .el-tree-node__expand-icon {
          font-size: 16px;
        }

        .field-node-content {
          display: flex;
          align-items: center;
          color: #3d465a;
          font-size: 14px;
          line-height: 20px;
          flex: 1;
          width: 0;

          .node-item {
            position: relative;
            flex: 1;
            width: 0;
            padding-right: 30px;

            .node-item-chekck-rule-btn {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              font-size: 14px;
              color: #9599a5;
            }
          }
          .field-node-del-icon {
            padding: 4px;
            cursor: pointer;
            font-size: 14px;
            color: #9599a5;
            opacity: 0;
          }

          &:hover {
            .field-node-del-icon {
              opacity: 1;
            }
          }
        }
      }
    }

    .field-pane-search-ul {
      box-sizing: border-box;
      flex: 1;
      height: 0;
      width: 100%;
      overflow: auto;
      padding: 0 20px;
      &::-webkit-scrollbar {
        display: none;
      }

      .field-pane-search-li {
        display: flex;
        align-items: flex-start;
        border-bottom: 1px solid #e8ebef;
        padding: 10px 0;
        cursor: pointer;

        &:hover {
          background-color: #eaf6ff;
        }

        .field-li-tag {
          width: 50px;
          color: #3d465a;
          font-size: 12px;
          text-align: center;
          line-height: 20px;
          background-color: #f1f3f6;
        }
        .field-li-info {
          flex: 1;
          width: 0;
          margin-left: 4px;
          .field-li-title {
            color: #3d465a;
            font-size: 14px;
            line-height: 20px;
          }
          .field-li-fullname {
            color: #9599a5;
            font-size: 12px;
            line-height: 18px;
            margin-top: 2px;
          }
        }
        .field-li-check {
          margin: 4px;
        }
      }
    }
  }

  .field-pane-tools {
    text-align: right;
    margin: 20px;
  }
}
</style>
